import { platformIcons } from "@assets/images";

const styles = {
  platformIconContainer: {
    width: "40px",
    display: "flex",
    alignItems: "center",
  },

  platformIcon: {
    //    height: "12px",
    width: "20px",
  },
};

const DisplayPlatforms = (props) => {
  let {
    platformId, // 9, 10, or null
  } = props;

  return (
    <div
      className="platform-info-container"
      style={styles.platformIconContainer}
    >
      {[9, null].includes(platformId) ? (
        <div className="apple-i-container">
          <img
            className="img"
            style={styles.platformIcon}
            src={platformIcons.ios.inactive}
          />
        </div>
      ) : null}
      {[10, null].includes(platformId) ? (
        <div className="android-i-container" style={{ marginLeft: "8px" }}>
          <img
            className="img"
            style={styles.platformIcon}
            src={platformIcons.android.inactive}
          />
        </div>
      ) : null}
    </div>
  );
};

export default DisplayPlatforms;
